import { render, staticRenderFns } from "./typeList.vue?vue&type=template&id=aaf2eb3c&scoped=true&"
import script from "./typeList.vue?vue&type=script&lang=js&"
export * from "./typeList.vue?vue&type=script&lang=js&"
import style0 from "./typeList.vue?vue&type=style&index=0&id=aaf2eb3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf2eb3c",
  null
  
)

export default component.exports